import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = { key: 5 }
const _hoisted_7 = { key: 6 }
const _hoisted_8 = { key: 7 }
const _hoisted_9 = { key: 8 }
const _hoisted_10 = {
  key: 9,
  class: "text-icon"
}
const _hoisted_11 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  width: "20",
  height: "20",
  viewBox: "0 0 172 172",
  style: {"fill":"#000000"}
}

import QuickReplyIcon from 'vue-material-design-icons/PlaylistCheck.vue';
import TriggerIcon from 'vue-material-design-icons/Flash.vue';
import QuestionIcon from 'vue-material-design-icons/ForumOutline.vue';
import LinkedPathsIcon from 'vue-material-design-icons/CallSplit.vue';
import PauseBotIcon from 'vue-material-design-icons/Pause.vue';
import DragIcon from '@/shared/components/DragIcon.vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import DecisionIcon from 'vue-material-design-icons/SourceBranch.vue';
import GoToIcon from '@/shared/icons/GoToIcon.vue';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IslandBadge',
  props: {
  type: {
    type: String,
    required: true,
  },
  draggable: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {


const showDragIcon = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["island-badge", __props.type]),
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (showDragIcon.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showDragIcon.value = false))
  }, [
    (__props.type === 'inputstring' && !showDragIcon.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(QuestionIcon, { class: "icon-1-3x" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'decision' && !showDragIcon.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(DecisionIcon, { class: "icon-1-5x" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'appintegration' && !showDragIcon.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_font_awesome_icon, { icon: "cube" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'parentflows')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(FlowIcon, { class: "icon-1-5x" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'linkedpaths')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(LinkedPathsIcon, { class: "icon-1-5x fa-flip-vertical path-icon" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'quickreply')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(QuickReplyIcon, { class: "icon-1-5x" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'trigger')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(TriggerIcon, { class: "icon-1-5x" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'humanhandover')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(PauseBotIcon, { class: "icon-1-5x" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'goto')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(GoToIcon, { class: "icon-1-3x" })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'text' && !showDragIcon.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[2] || (_cache[2] = [
            _createElementVNode("g", {
              fill: "none",
              "fill-rule": "nonzero",
              stroke: "none",
              "stroke-width": "1",
              "stroke-linecap": "butt",
              "stroke-linejoin": "miter",
              "stroke-miterlimit": "10",
              "stroke-dasharray": "",
              "stroke-dashoffset": "0",
              "font-family": "none",
              "font-weight": "none",
              "font-size": "none",
              "text-anchor": "none",
              style: {"mix-blend-mode":"normal"}
            }, [
              _createElementVNode("path", {
                d: "M0,172v-172h172v172z",
                fill: "none"
              }),
              _createElementVNode("g", { fill: "#ffffff" }, [
                _createElementVNode("path", { d: "M85.83203,22.77656c-0.54801,0.01312 -1.09438,0.06551 -1.63489,0.15677h-44.0638h-5.73333c-3.1648,0 -5.73333,2.56853 -5.73333,5.73333v17.2c0,3.1648 2.56853,5.73333 5.73333,5.73333h5.73333c3.1648,0 5.73333,-2.56853 5.73333,-5.73333v-5.73333h28.66667v91.73333h-5.73333c-3.1648,0 -5.73333,2.56853 -5.73333,5.73333v5.73333c0,3.1648 2.56853,5.73333 5.73333,5.73333h15.34114c1.23099,0.20221 2.48672,0.20221 3.71771,0h15.34114c3.1648,0 5.73333,-2.56853 5.73333,-5.73333v-5.73333c0,-3.1648 -2.56853,-5.73333 -5.73333,-5.73333h-5.73333v-91.73333h28.66667v5.73333c0,3.1648 2.56853,5.73333 5.73333,5.73333h5.73333c3.1648,0 5.73333,-2.56853 5.73333,-5.73333v-17.2c0,-3.1648 -2.56853,-5.73333 -5.73333,-5.73333h-5.73333h-44.03021c-0.66226,-0.11084 -1.33298,-0.1633 -2.00442,-0.15677z" })
              ])
            ], -1)
          ])))
        ]))
      : _createCommentVNode("", true),
    (__props.draggable && showDragIcon.value)
      ? (_openBlock(), _createBlock(DragIcon, {
          key: 10,
          class: "icon-1-5x"
        }))
      : _createCommentVNode("", true)
  ], 34))
}
}

})